<template>
    <div class="navbar-header">
        <div class="location">
            <div class="icon icon-location">
                <svg-icon icon="location"></svg-icon>
            </div>
            <p>Rua dos Pinheiros, 20 - 6º andar - São Paulo - SP</p>
        </div>
        <div class="social">
            <a href="https://twitter.com/sp_ugt" target="_blank" class="social-link">
                <svg-icon icon="twitter"></svg-icon>
            </a>
            <a href="https://www.facebook.com/ugtsp" target="_blank" class="social-link">
                <svg-icon icon="facebook"></svg-icon>
            </a>
            <a href="https://youtube.com/channel/UCeMrGI2nKGKFQWQ0DEIUUVg" target="_blank" class="social-link">
                <svg-icon icon="youtube"></svg-icon>
            </a>
            <a href="/sistema" class="social-link">
                <svg-icon icon="tv"></svg-icon>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'navbar-header',
}
</script>

<style lang="scss" scoped>
.navbar-header {
    @apply h-20 flex justify-between py-0 px-24;
    border-bottom: 1px solid #fff;
    @media (max-width: 768px) {
        @apply hidden;
    }
    .location {
        @apply flex items-center;
        & > p {
            @apply ml-4;
        }
    }
    .social {
        @apply flex;
        .social-link {
            @apply p-8 text-white;
            border-left: 1px solid #fff;
            border-right: 1px solid #fff;
            color: #fff;

            &:hover {
                @apply text-secondary;
            }
        }
    }
}
</style>
